<template>
  <v-select v-model="courseSelected"
            :items="itemCourses"
            item-text="name"
            item-value="id"
            menu-props="auto"
            placeholder="Wszystkie kierunki"
            single-line
            multiple
            chips
            deletable-chips
            class="ml-4"
  >
  </v-select>
</template>
<script>
import {mapActions, mapGetters} from "vuex";

export default {
  name: 'SelectCourses',
  methods: {
    ...mapActions({
      setCourseSelected: 'courses/setCourseSelected',
    })
  },

  computed: {
    ...mapGetters({
      courseSelectedFromStore: 'courses/getCourseSelected',
      courses: 'courses/getCourses'
    }),
    itemCourses() {
      let courses = Object.assign(this.courses, this.courses)
      courses.push({ 'id': '', 'name': 'Wszystkie kierunki'})
      return courses;
    },
    courseSelected: {
      get() {
        return this.courseSelectedFromStore
      },
      set(value){
        this.$emit('courseChanged', value)
        return this.setCourseSelected(value)
      }
    },
  }
}
</script>
<style scoped>
::v-deep .v-chip {
  height: auto !important;
}

::v-deep .v-chip .v-chip__content {
  max-width: 100%;
  height: auto;
  min-height: 32px;
  white-space: pre-wrap;
}
</style>
